import React from "react";
import PageContainer from 'publish/layout/PageContainer';
import LayoutAside from "../LayoutAside"
import CommonUtil from "../../../utils/CommonUtil";
import CodeDataStore from "../../../common/codedata/store/CodeDataStore";
import TbComFile from "../../../domain/main/com/file/TbComFile";
import TbComFileMapngDetail from "../../../domain/main/com/file/mapng/TbComFileMapngDetail";
import Breadcrumb from "../../../layouts/main/Breadcrumb";
import UIInput from "../../../components/input/input";
import UI from "../../../components/UI";
import StringUtil from "../../../utils/StringUtil";
import Button from "../../../components/buttons";

export default ContentsContainer;

function ContentsContainer(props: any) {
    const [formId] = React.useState("sendForm");
    const [id, setId] = React.useState("");
    const [fileValue, setFileValue] = React.useState<TbComFile>();

    const [detail, setDetail] = React.useState<{
        rede: any;
        pay: any;
        tsk: any;
        member: any;
    }>({
        rede: {},
        pay: {},
        tsk: {},
        member: {}
    });

    const codeDatas = React.useDeferredValue(() => CodeDataStore.read(
        "/common/yesNoYN",
        "/admin.bizmanage/bkc",
        "/admin.bizmanage/btc",
        "[FPUC]",
        "[FPUN]",
        "[DRIK]",
        "[PCY]",
        "[DRICC]",
        "common.commbiz.commBizByBizTpCdBC",
        "/common/bbsSearchType"
    ).then(() => {
        return {
            "/common/yesNoYN": CodeDataStore.get("/common/yesNoYN"),
            "/admin.bizmanage/bkc": CodeDataStore.get("/admin.bizmanage/bkc"),
            "/admin.bizmanage/btc": CodeDataStore.get("/admin.bizmanage/btc"),
            "[FPUC]": CodeDataStore.get("[FPUC]"),
            "[FPUN]": CodeDataStore.get("[FPUN]"),
            "[DRIK]": CodeDataStore.get("[DRIK]"),
            "[PCY]": CodeDataStore.get("[PCY]"),
            "[DRICC]": CodeDataStore.get("[DRICC]"),
            "common.commbiz.commBizByBizTpCdBC": CodeDataStore.get("common.commbiz.commBizByBizTpCdBC"),
            "/common/bbsSearchType": CodeDataStore.get("/common/bbsSearchType")
        }
    }))

    let param = {
        "REDE_REQ_NO": 'R240000008'
        , "PAY_REQ_NO": 'Y240000295'
        , "TSK_REQ_NO": 'T2300743'
        , "TSK_REQ_MODI_SEQ": localStorage.getItem("tskReqModiSeq")
    };

    const deferredFileValue = React.useDeferredValue(fileValue);

    //상세정보 값 가지고 오기
    function getInfo(name, type) {
        if (type == 'rede') {
            if (Object.keys(detail.rede).length != 0) {
                return detail.rede[name];
            } else {
                return '';
            }
        } else if (type == 'pay') {
            if (Object.keys(detail.pay).length != 0) {
                return detail.pay[name];
            } else {
                return '';
            }
        } else if (type == 'tsk') {
            if (Object.keys(detail.tsk).length != 0) {
                return detail.tsk[name];
            } else {
                return '';
            }
        } else if (type == 'user') {
            if (Object.keys(detail.member).length != 0) {
                return detail.member[name];
            } else {
                return '';
            }
        }
    };

    function dateToStr(dateText) {

        if (dateText == null) return '';

        if (/^(-?)[0-9]+$/.test(dateText)) {
            dateText = Number(dateText);
        }
        let date = new Date(dateText);
        let week = new Array('일', '월', '화', '수', '목', '금', '토');


        let year = date.getFullYear();
        let month = date.getMonth() + 1;
        let day = date.getDate();
        let dayName = week[date.getDay()];

        return year + '-' + dateLpad(String(month)) + '-' + dateLpad(String(day)) + '(' + dayName + ')';
    }

    //날짜 0 처리
    function dateLpad(num) {
        let strNum = num;
        if (strNum.length == 1) {
            strNum = "0" + strNum;
        }

        return strNum;
    }

    const response = React.useDeferredValue(() => CommonUtil.execute({
        url: 'usr_2137_redeDetail',
        data: param
    }));


    React.useEffect(() => {
        console.log("codeDatas", codeDatas())
        response().then((result: any) => {
            setDetail({
                rede: result.REDE_DETAIL,
                pay: result.PAY_DETAIL,
                tsk: result.TSK_DETAIL,
                member: result.PERSON_DETAIL
            })

            let fileInfoList = result.FILE_INFO_LIST;
            if (fileInfoList != null) {
                const tempFileValue = new TbComFile();
                fileInfoList?.forEach((item, index) => {
                    const fileDetail = new TbComFileMapngDetail();
                    fileDetail.setDwldId(item.DWLD_ID);
                    fileDetail.setFileDetailId(item.FILE_DETAIL_ID);
                    fileDetail.setFilePolicy(item.FILE_POLICY);
                    fileDetail.setFileRpstr(item.FILE_RPSTR);
                    fileDetail.setStrePath(item.STRE_PATH);
                    fileDetail.setStreFileNm(item.STRE_FILE_NM);
                    fileDetail.setOrginlFileNm(item.ORGINL_FILE_NM);
                    fileDetail.setFileExtsn(item.FILE_EXTSN);
                    fileDetail.setFileSize(Number(item.FILE_SIZE));
                    fileDetail.setRegistDt(item.REGIST_DT);
                    fileDetail.setRegistPsnNm(item.REGIST_PSN_NM);

                    tempFileValue.putTbComFileMapngDetailList(fileDetail);
                });
                setFileValue(tempFileValue);
            }
        })
    }, [])

    return (
        <PageContainer session={false}>
            <LayoutAside/>
            <div className="fww-con">
                <Breadcrumb gnbIdx={2} lnbIdx={4}/>
                <main className="fww-main">
                    <h1 className="tx tx-hd2">환수신청 상세</h1>
                    <div className="fo fo-col2">
                        <div className="inner">
                            <div className="fo-item">
                                <p className="fo-key">환수신청번호</p>
                                <div className="fo-value">
                                    <UIInput className={'tf tf-md w100p'} value={detail.rede.REDE_REQ_NO || ''}
                                             placeholder={''} readOnly={true}/>
                                </div>
                            </div>
                            <div className="fo-item">
                                <p className="fo-key">진행상태</p>
                                <div className="fo-value">
                                    {(() => {
                                        switch (detail.rede.REDE_REQ_STS_CD) {
                                            case "A":
                                                return <span className="badge badge-22 blue">신청</span>
                                            case "F":
                                                return <span className="badge badge-22 green">최종접수</span>
                                            case "C":
                                                return <span className="badge badge-22 yellow">수정요청</span>
                                            case "B":
                                                return <span className="badge badge-22 skyblue">접수중</span>
                                            case "G":
                                                return <span className="badge badge-22 black">환수완료</span>
                                            default:
                                                return <></>
                                        }
                                    })()}
                                </div>
                            </div>
                            <div className="fo-item">
                                <p className="fo-key">환수 신청일</p>
                                <div className="fo-value">
                                    <UIInput className={'tf tf-md w100p'}
                                             value={dateToStr(detail.rede.REDE_REQ_DATE || '')} placeholder={''}
                                             readOnly={true}/>
                                </div>
                            </div>
                            <div className="fo-item">
                                <p className="fo-key">환수완료일</p>
                                <div className="fo-value">
                                    <UIInput className={'tf tf-md w100p'}
                                             value={dateToStr(detail.rede.REDE_COMPL_DATE)} placeholder={''}
                                             readOnly={true}/>
                                </div>
                            </div>
                            <div className="fo-item">
                                <p className="fo-key">환수 금액</p>
                                <div className="fo-value">
                                    <div className="tf-unit hz-item w100p">
                                        <UIInput className={'tf tf-md ta-right'}
                                                 value={StringUtil.formatNumber(detail.rede.REDE_AMT, 0)}
                                                 placeholder={''} readOnly={true}/>
                                        <span className="u">원</span>
                                    </div>
                                </div>
                            </div>
                            <div className="fo-item">
                                <p className="fo-key">환수 기업수</p>
                                <div className="fo-value">
                                    <div className="hz-root hz-sb w100p">
                                        <div className="hz-root hz-gap5 ">
                                            <UIInput className={'tf tf-md ta-right hz-item hz-fg'}
                                                     value={detail.rede.REDE_CORP_CNT} placeholder={''}
                                                     readOnly={true}/>
                                            <p className="tx-msg hz-item">개사</p>
                                        </div>
                                        <Button color='gray-o' size="md">환수기업내역</Button>
                                    </div>
                                </div>
                            </div>
                            <div className="fo-item">
                                <p className="fo-key">제출여부</p>
                                <div className="fo-value">
                                    <UIInput className={'tf tf-md w100p'} value={detail.rede.SUB_YN}
                                             placeholder={''} readOnly={true}/>
                                </div>
                            </div>
                            <div className="fo-item">
                                <p className="fo-key">환수계좌</p>
                                <div className="fo-value">
                                    <UIInput className={'tf tf-md w100p'} value={detail.rede.BANK_CD}
                                             placeholder={''} readOnly={true}/>
                                </div>
                            </div>
                            <div className="fo-item fo-m-1-3">
                                <p className="fo-key">환수 사유</p>
                                <div className="fo-value">
                                    <UIInput className={'tf tf-md w100p'} value={detail.rede.REDE_REASON}
                                             placeholder={''} readOnly={true}/>
                                </div>
                            </div>

                        </div>
                    </div>

                    {/* 첨부파일 */}
                    <section className="fund-section">
                        <div className="hz-root hz-sb mb15">
                            <h3 className="section-title">첨부파일</h3>
                            {/* <Button color='gray-o' size="sm">첨부파일수정</Button>  */}
                        </div>
                        <div className="fo fo-col2">
                            <div className="inner">
                                <div className="fo-item fo-m-1-3 req">
                                    <p className="fo-key">환수 신청서</p>
                                    <div className="fo-value ">
                                        <div className="fund-form-group">
                                            <div className="fund-form-items">
                                                <UI.FileDownload value={deferredFileValue} className={'w100p'}/>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </section>
                </main>
            </div>
        </PageContainer>
    );
}
